import React, { useEffect } from "react";
import { useTheme, withStyles } from "@material-ui/core/styles";
import "fontsource-muli";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../components/CustomText";
import CustomModal from "../../../components/CustomModal";
import Color from "../../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomButton from "../../../components/CustomButton";

const FileManagerErrorPrompt = ({
  classes,
  isVisible,
  onClickAgree,
  onClickDisagree,
  onClickImportantNotice,
  handleClose,
  retryEnrol,
  onClickMisMatchYes,
  onClickMisMatchNo,
  visibleErrorPrompt,
  errorMsg,
}) => {
  const modalContainer = () => {
    return (
      <div className={classes.containerStyle}>
       <Grid
          item
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft:"5%",paddingRight:"5%",marginBottom:"1.5%"
          }}
        >
          {" "}
         
            <CustomText design={classes.titleTextStyle}>
             Something went wrong
            </CustomText>
         
        </Grid>
         <Grid
          item
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft:"10%",paddingRight:"10%",marginBottom:"3%"
          }}
        >
          {" "}
         
            <CustomText design={classes.subTitle}>
            {errorMsg !== " " ? errorMsg : "An error occured. Please contact agent to resend the file."}
            
            </CustomText>
         
        </Grid>

        {/* <Grid container style={{display:"flex",justifyContent:"space-between",paddingLeft:"5%",paddingRight:"5%"}} >
          <Grid item xs={5} >
          <CustomButton
            onClick={onClickMisMatchYes}
            style={{ textTransform: "none", }}
            design={classes.cancelButtonTextStyle}
          >
            Yes
          </CustomButton>
          </Grid>
          <Grid item xs={2} >
        
          </Grid>
          <Grid item xs={5}>
          <CustomButton
            onClick={onClickMisMatchNo}
            style={{ textTransform: "none" }}
            design={classes.cancelButtonTextStyle}
          >
            No
          </CustomButton>
          </Grid>
        </Grid> */}
      </div>
    );
  };

  return (
    <div>
      <CustomModal
        open={visibleErrorPrompt}
        handleClose={handleClose}
        titlestyle={classes.modalTitleStyle}
        modalDesign={classes.modalDesign}
        isVisibleCloseButton={false}
        //submitButtonText={"I Agree"}
        //cancelButtonText={"I Disagree"}
        modalComponent={modalContainer()}
        disableBackdropClick
        handleSubmitButton={onClickAgree}
        handleCancelButton={onClickDisagree}
      />
    </div>
  );
};

const styles = (theme) => ({
  containerStyle: {
    flexGrow: 1,
    marginBottom: 30,
    paddingRight: 20,
    minWidth:window.innerWidth > 600 ? "450px" : "250px",
  },
  modalTitleStyle: {
    ...getFontSize("large"),
  },
  titleTextStyle: {
    ...getFontSize("large"),
    ...getFontWeight("bold"),
   
    textAlign: "center",
    fontFamily:"Muli",
    fontSize:"22px"
  },
  descTitleTextStyle: {
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  descTextStyle: {
    ...getFontSize("small"),
    lineHeight: 1.4,
    marginBottom: 5,
  },
  modalDesign: {
    minWidth: "280px",
    maxWidth: "700px",
    textInputStyle: {
      height: 35,
      marginLeft: 5,
      marginRight: 5,
    },
  },
  tooltipContainer: {
    display: "flex",
    alignItems: "center",
  },
  infoIconStyle: {
    width: "17px",
    height: "17px",
    alignSelf: "center",
    color: Color.secondaryTextColor,
    marginLeft: 10,
  },
  tooltipTextStyle: {
    color: Color.secondaryTextColor,
    ...getFontWeight("normal"),
  },
  highLightedTextStyle: {
    color: Color.primaryColor,
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  textInputContainer: {
    height: 40,
    marginLeft: 10,
  },
  dividerStyle: {
    marginTop: 20,
    marginBottom: 20,
  },
  paymentInputContainer: {
    height: 40,
    [theme.breakpoints.only("xs")]: {
      width: 150,
    },
    width: 300,
  },
  paymentInputTitleTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("small"),
    marginBottom: 2,
    color: Color.primaryTextColor,
  },
  p: {
    position: "relative",
    //margin: "20px",
    marginLeft: "10%",
    marginBottom: "2%",
  },
  bulletStyle: {
    position: "absolute",
    left: "-40px",
    top: "10%",
    transform: "translate(0%,-50%)",
    fontWeight: "bold",
  },
  noteTextStyle:{
      fontFamily:"Muli",
      fontSize:"16px",
      fontWeight:"400",
      color:"#424143"
  },
  subTitle:{
    fontFamily:"Muli",
    fontSize:"16px",
    fontWeight:"400",
    color:"#424143"
  },
  cancelButtonTextStyle: {
    backgroundColor: "#fff",
    color: "#424143",
    borderRadius: 8,
    "&:focus": {
      color: "white",
      //backgroundColor: Color.blackButtonColor,
      opacity: 1.0
    },
    "&:hover": {
      color: "white",
     // backgroundColor: Color.blackButtonColor
    }
  },
});

export default withStyles(styles, { withTheme: true })(FileManagerErrorPrompt);
